export function MainMenu(Collapse) {
  // DOM
  const mainMenu = document.getElementById('main-menu');
  // const header = document.querySelector('.site-header');
  const toggler = document.querySelector('.navbar-toggler');
  // const submenuToggles = document.querySelectorAll('#main-menu .dropdown-toggle');
  const hero = document.querySelector('.hero');
  // const heroContent = document.querySelector('.hero__content__txt');

  // Vars
  // const menu = new Collapse(mainMenu, {
  //   toggle: false,
  // });
  // const hideMenuThreshold = 900;
  // const breakpoint = 992;
  // const numDrops = submenuToggles.length;
  // let initialLoad = true;
  // let numLoaded = 0;

  // Methods
  const init = () => {
    _addListeners();
    _checkWindow();
    _checkMenuScroll();
  };

  const _addListeners = () => {
    //   // navbarSearchToggle.addEventListener('click', (e) => {
    //   //   navbarSearchForm.classList.toggle('show');
    //   // });

    mainMenu.addEventListener('show.bs.collapse', _handleShowCollapse, false);
    mainMenu.addEventListener('hide.bs.collapse', _handleHideCollapse, false);

    window.addEventListener('scroll', (e) => {
      _checkMenuScroll();
    });

    window.addEventListener('resize', (e) => {
      _checkWindow();
    });
  };

  const _checkWindow = (e) => {
    //   //   navbar.style.top = notificationBar.offsetHeight + languageBar.offsetHeight + 'px';
    //   if (window.innerWidth < breakpoint) {
    //     _initMobile();
    //   } else {
    //     _initDesktop();
    //   }
  };

  // const _initMobile = () => {
  // _checkNotificationScroll();
  // _checkMenuScroll();
  // navbar.classList.remove('navbar--submenu-open');

  // submenuToggles.forEach((val, key) => {
  //   const instance = Dropdown.getInstance(val);

  //   if (instance !== null) {
  //     instance.hide();
  //   }
  // });

  // submenuToggles.forEach((val, key) => {
  //   val.removeEventListener('show.bs.dropdown', _handleShowDropdownDesktop, false);
  //   val.addEventListener('show.bs.dropdown', _handleShowDropdownMobile, false);
  // });

  // window.addEventListener('scroll', (e) => {
  //   // _checkNotificationScroll();
  //   _checkMenuScroll();
  // });
  // };

  // const _initDesktop = () => {
  //   // _checkNotificationScroll();
  //   _checkMenuScroll();
  //   menu.hide();

  //   document.body.classList.remove('menu-open');

  //   mainMenu.removeEventListener('show.bs.collapse', _handleShowCollapse, false);
  //   mainMenu.removeEventListener('hide.bs.collapse', _handleHideCollapse, false);

  //   submenuToggles.forEach((val, key) => {
  //     val.removeEventListener('show.bs.dropdown', _handleShowDropdownMobile, false);
  //     val.addEventListener('show.bs.dropdown', _handleShowDropdownDesktop, false);
  //     val.addEventListener('hide.bs.dropdown', _handleHideDropdownDesktop, false);
  //   });

  //   window.addEventListener('scroll', (e) => {
  //     // _checkNotificationScroll();
  //     _checkMenuScroll();
  //   });
  // };

  const _checkMenuScroll = () => {
    //   // console.log(hero.offsetHeight);
    //   if (heroContent) {
    //     if (window.scrollY / (hero.offsetHeight - 200) < 1) {
    //       heroContent.style.opacity = 1 - window.scrollY / (hero.offsetHeight - 400);
    //     }
    //   }

    if (hero.offsetHeight === 0) {
      // page has no hero
      if (window.scrollY < 150) {
        document.body.classList.remove('sticky-header');
      } else {
        document.body.classList.add('sticky-header');
      }
    } else {
      if (window.scrollY < hero.offsetHeight - 200) {
        document.body.classList.remove('sticky-header');
      } else {
        document.body.classList.add('sticky-header');
      }
    }
  };

  const _handleShowCollapse = (e) => {
    document.body.classList.add('menu-open');
    toggler.classList.add('is-active');
    // navbarSearchForm.classList.remove('show');
  };

  const _handleHideCollapse = (e) => {
    document.body.classList.remove('menu-open');
    toggler.classList.remove('is-active');
  };

  // const _handleShowDropdownMobile = (e) => {
  // console.log('_handleShowDropdownMobile :: ', e);
  // navbar.classList.add('navbar--submenu-open');
  // navbarTitle.classList.remove('d-none');
  // navbarTitle.innerHTML = e.target.innerHTML;
  // };

  // let anotherDropdownClicked = false;
  // let prevDropdown = null;

  // const _handleShowDropdownDesktop = (e) => {
  //   // console.log('_handleShowDropdownDesktop :: ', e.target);
  //   anotherDropdownClicked = true;
  //   prevDropdown = e.target;
  //   e.target.classList.add('active');
  //   navbar.classList.add('navbar--submenu-open');
  //   // navbarSearchForm.classList.remove('show');
  // };

  // const _handleHideDropdownDesktop = (e) => {
  //   // console.log('_handleHideDropdownDesktop :: ', e);
  //   e.target.classList.remove('active');
  //   if (!anotherDropdownClicked || prevDropdown === e.target) {
  //     navbar.classList.remove('navbar--submenu-open');
  //   }
  //   // navbarSearchForm.classList.remove('show');
  //   anotherDropdownClicked = false;
  //   prevDropdown = e.target;
  // };

  return { init };
}
